<div class="flex-horizontal section-title-container">
  <div class="section-heading">
    <div class="section-title">Manage your API Specifications</div>
    <div class="dds-label greyed-out">
      Here you can view the API Specifications added to your project, update them and add new ones.
    </div>
  </div>
  <div>
    <dds-button
      [theme]="createSpecificationButtonOptions.theme"
      [kind]="createSpecificationButtonOptions.kind"
      [size]="createSpecificationButtonOptions.size"
      [width]="createSpecificationButtonOptions.width"
      [icon]="createSpecificationButtonOptions.icon"
      [isIconLeft]="createSpecificationButtonOptions.isIconLeft"
      [role]="createSpecificationButtonOptions.role"
      [isInverse]="createSpecificationButtonOptions.isInverse"
      [isColorBg]="createSpecificationButtonOptions.isColorBg"
      [isLoading]="createSpecificationButtonOptions.isLoading"
      [ariaLabel]="createSpecificationButtonOptions.ariaLabel"
      [customClass]="createSpecificationButtonOptions.customClass"
      (clicked)="createSpecificationClick()"
      >Add a new API Specification</dds-button
    >
  </div>
</div>

<div class="flex-horizontal dds-mb-3">
  <div>
    <div class="dds-label greyed-out">API Specification</div>
    <div>
      <dds-dropdown
        [theme]="dropdownOptions.theme"
        [kind]="dropdownOptions.kind"
        [size]="dropdownOptions.size"
        [label]="dropdownOptions.label"
        [width]="dropdownOptions.width"
        [isInverse]="dropdownOptions.isInverse"
        [isColorBg]="dropdownOptions.isColorBg"
        [disabled]="dropdownOptions.disabled"
        [customClass]="dropdownOptions.customClass"
        [isResponsive]="dropdownOptions.isResponsive"
        [stickerWidth]="dropdownOptions.stickerWidth"
        [stickerIsOutsideClick]="dropdownOptions.stickerIsOutsideClick"
        [stickerShift]="dropdownOptions.stickerShift"
        [stickerMaxHeight]="dropdownOptions.stickerMaxHeight"
        [stickerIsDisabled]="dropdownOptions.stickerIsDisabled"
        [stickerPosition]="dropdownOptions.stickerPosition"
        [stickerIndent]="dropdownOptions.stickerIndent"
        [stickerCustomClass]="dropdownOptions.stickerCustomClass"
        [stickerIsDynamic]="dropdownOptions.stickerIsDynamic"
        (itemSelected)="itemSelected($event)"
      >
        @for (item of dropdownItems; track item) {
        <dds-dropdown-item [value]="item.value" [counter]="item.counter" [disabled]="item.disabled">{{
          item.heading
        }}</dds-dropdown-item>
        }
      </dds-dropdown>
    </div>
  </div>
  <div class="upload-button-container">
    <dds-button
      [theme]="uploadButtonOptions.theme"
      [kind]="uploadButtonOptions.kind"
      [size]="uploadButtonOptions.size"
      [width]="uploadButtonOptions.width"
      [icon]="uploadButtonOptions.icon"
      [isIconLeft]="uploadButtonOptions.isIconLeft"
      [role]="uploadButtonOptions.role"
      [isInverse]="uploadButtonOptions.isInverse"
      [isColorBg]="uploadButtonOptions.isColorBg"
      [isLoading]="uploadButtonOptions.isLoading"
      [ariaLabel]="uploadButtonOptions.ariaLabel"
      [customClass]="uploadButtonOptions.customClass"
      (clicked)="uploadButtonClick()"
      >Upload a new version</dds-button
    >
  </div>
</div>

<div class="flex-horizontal api-spec-container">
  <div>
    <dds-button
      [theme]="sourceButtonOptions.theme"
      [kind]="sourceButtonOptions.kind"
      [size]="sourceButtonOptions.size"
      [width]="sourceButtonOptions.width"
      [icon]="sourceButtonOptions.icon"
      [isIconLeft]="sourceButtonOptions.isIconLeft"
      [role]="sourceButtonOptions.role"
      [isInverse]="sourceButtonOptions.isInverse"
      [isColorBg]="sourceButtonOptions.isColorBg"
      [isLoading]="sourceButtonOptions.isLoading"
      [ariaLabel]="sourceButtonOptions.ariaLabel"
      [customClass]="sourceButtonOptions.customClass"
      (clicked)="sourceClick()"
      >Source</dds-button
    >
    <dds-button
      [theme]="previewButtonOptions.theme"
      [kind]="previewButtonOptions.kind"
      [size]="previewButtonOptions.size"
      [width]="previewButtonOptions.width"
      [icon]="previewButtonOptions.icon"
      [isIconLeft]="previewButtonOptions.isIconLeft"
      [role]="previewButtonOptions.role"
      [isInverse]="previewButtonOptions.isInverse"
      [isColorBg]="previewButtonOptions.isColorBg"
      [isLoading]="previewButtonOptions.isLoading"
      [ariaLabel]="previewButtonOptions.ariaLabel"
      [customClass]="previewButtonOptions.customClass"
      (clicked)="previewClick()"
      >Preview</dds-button
    >
  </div>
  <div>{{ specificationDescription }}</div>

  <dds-button
    [theme]="copyButtonOptions.theme"
    [kind]="copyButtonOptions.kind"
    [size]="copyButtonOptions.size"
    [width]="copyButtonOptions.width"
    [icon]="copyButtonOptions.icon"
    [isIconLeft]="copyButtonOptions.isIconLeft"
    [role]="copyButtonOptions.role"
    [isInverse]="copyButtonOptions.isInverse"
    [isColorBg]="copyButtonOptions.isColorBg"
    [isLoading]="copyButtonOptions.isLoading"
    [ariaLabel]="copyButtonOptions.ariaLabel"
    [customClass]="copyButtonOptions.customClass"
    (clicked)="copyClick()"
  ></dds-button>
</div>
@if (showPreview) {
<div #swagger></div>
} @else {
<div class="ace-wrapper">
  <ace [config]="config" [mode]="editorMode" [theme]="'github'" [(value)]="specificationContent"></ace>
</div>
}
